import script from "./game.vue?vue&type=script&setup=true&lang=ts"
export * from "./game.vue?vue&type=script&setup=true&lang=ts"

import "./game.vue?vue&type=style&index=0&id=cf9fd1c6&lang=scss"

const __exports__ = script;

export default __exports__